import React, { FC, PropsWithChildren, ReactNode } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { VoidHandler, WithDataName } from 'common/types'

import { QuotesSvg } from '../svgr/QuotesSvg'
import { WaveUnderlineLongSvg } from '../svgr/WaveUnderlineLongSvg'
import { WaveUnderlineShortOrangeSvg } from '../svgr/WaveUnderlineShortOrangeSvg'
import { WaveUnderlineShortSvg } from '../svgr/WaveUnderlineShortSvg'
import { Props, Typography } from '../Typography/Typography'

export const TextWaveUnderline: FC<
  {
    title: ReactNode | string
    variant?: 'short' | 'with-quotes' | 'short-orange'
    onClick?: VoidHandler
  } & PropsWithChildren &
    Props &
    WithDataName
> = ({
  title,
  variant = 'short',
  onClick,
  fontSize,
  fontWeight,
  className,
  style,
  ...rest
}) => {
  switch (variant) {
    case 'with-quotes':
      return (
        <Parent
          className={cx(className, gridQuotesCss)}
          style={style}
          onClick={onClick}
        >
          <Title
            fontSize={fontSize}
            fontWeight={fontWeight}
            data-name={rest['data-name']}
          >
            {title}
          </Title>
          <QuotesSvg />
          <WaveDefaultQuotes />
        </Parent>
      )

    case 'short-orange':
      return (
        <Parent className={cx(className)} style={style} onClick={onClick}>
          <Typography
            fontSize={fontSize}
            fontWeight={fontWeight}
            className={cx(orangeColorCss)}
            data-name={rest['data-name']}
          >
            {title}
          </Typography>
          <WaveOrange />
        </Parent>
      )

    default:
      return (
        <Parent className={cx(className)} style={style} onClick={onClick}>
          <Typography
            fontSize={fontSize}
            fontWeight={fontWeight}
            data-name={rest['data-name']}
          >
            {title}
          </Typography>
          <WaveDefault />
        </Parent>
      )
  }
}

const Parent = styled.div`
  display: inline-grid;
  grid-template-rows: 1fr;
  grid-auto-columns: min-content;
  white-space: nowrap;
`

const orangeColorCss = css`
  color: var(--mamba-default);
`

const gridQuotesCss = css`
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: center;
`

const Title = styled(Typography)`
  flex-grow: 1;
`

const WaveDefault = styled(WaveUnderlineShortSvg)`
  opacity: 0.32;
`

const WaveDefaultQuotes = styled(WaveUnderlineLongSvg)`
  opacity: 0.32;
  grid-row: 2 / 3;
  grid-column: 1 / 3;
`

const WaveOrange = styled(WaveUnderlineShortOrangeSvg)`
  opacity: 0.32;
`
